module.exports = __webpack_public_path__ + "img/Gallery_1_13.570e9775.jpeg";